import React, {
    Component
} from 'react';
import {
    domainUrl,
    rootDomainUrl
} from '../config/Config';
import {
    reactLoader,
    getTokenData,
    contentResizeLoad,
    showSmallLeftMenu,
    message,
    scrollToTop,
    hideleftbar,
    composcroll,
} from '../helpers/Common';
import {
    runValidation
} from '../helpers/Validation';
import {
    handleCheckbox,
    handleRadio,
    handleSequence,
    autoFocusNext,
    allowOnlyNumberInput,
} from '../helpers/Fields';
import Flowplayer from '../components/Flowplayer';
import VoiceRecorder from '../components/VoiceRecorder';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getLearningRoom} from '../actions/learningRoomAction';
import Imagezoom from '../components/Imagezoom';
import Confidencemeter from '../components/Confidencemeter';
const $ = window.$;

class RepeatTestonebyone extends Component {
    constructor(props) {
        super(props);
        this.compeletestatus = "";
        this.state = {
            testseqfields: [],
            componentStatus: this.props.data.status,
            evaluationPanel: false,
            testquestions: [],
            testcont: [],
            statusMessage: "",
            is_answered_all: 0,
            resultthank: '',
            resultpage:false,
            totalscore:0,
            outofscore:0,
            is_performance:false,
            percentage:'',
            confidence_meter:'',
        };
    }

getTestdetails(data) {
    reactLoader("show", "Please wait...");
    fetch(domainUrl + 'normal-test/getonebyonedet', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getTokenData()
        },
        body: JSON.stringify({
            data
        })
    }).then((response) => response.json()).then((responseJson) => {
        this.setState({
            testcont: responseJson.Mcq_details,
            testquestions: responseJson.McqQuestions,
            confidence_meter: responseJson.Mcq_details.confidence_meter,
            is_answered_all: responseJson.Mcq_details.is_answered_all,
   
        });
        setTimeout(() => {
            contentResizeLoad();
            showSmallLeftMenu();
            contentResizeLoad();
            reactLoader("hide");
        }, 200);
        if(this.state.testcont.imagezoom)
			{
				$(function() {
					$('[data-chittizoom]').chittizoom();
				});
			}
    });
}
componentDidMount() {
    const {
        data
    } = this.props;
    this.compeletestatus = data.status;
    data.takerepeatable=1;
    this.getTestdetails(data);
    setTimeout(() => {
        $('audio').on("play", function(me) {
            $('audio').each(function(i, e) {
                if (e !== me.currentTarget) {
                    this.pause();
                }
            });
        });
    }, 500)
}
componentWillReceiveProps(nextProps) {
    const {
        data
    } = nextProps;
    this.compeletestatus = data.status;
}
backToComponentList() {
    const {
        data
    } = this.props;
    this.props.switchback('component_list', data.learning_room_id, data.dlr_id);
    setTimeout(() => {
        composcroll();
        contentResizeLoad();
        hideleftbar();
    }, 400);
}


getoptions(ans_opt,imagezoomopt) {
    let op_val = '';
    switch (ans_opt.options) {
        case 'image':
            op_val = (imagezoomopt) ? <Imagezoom izsrc={rootDomainUrl+"admin/test_image_files/"+ans_opt.add_on_answer_image} izalt="" izwidth="150" izheight="150"/>
             : <img src={rootDomainUrl+"admin/test_image_files/"+ans_opt.add_on_answer_image} alt="" width="150" height="150"/>
            break;
        case 'audio':
            op_val = <audio controls controlsList="nodownload">
        <source src={rootDomainUrl+"admin/test_audio_files/"+ans_opt.add_on_answer_audio} type="audio/mpeg" />
        </audio>
            break;
        case 'video':
            op_val = this.video_frame(ans_opt.add_on_answer_video, '');
            break;
        default:
            op_val = <div dangerouslySetInnerHTML={{ __html:ans_opt.options}}></div>
            break;
    }
    return op_val;
}
goback(pre_question_id) {
    const {
        data
    } = this.props;
    reactLoader("show", "Please wait...");
    fetch(domainUrl + 'normal-test/repeatgetprevnxtdet', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getTokenData()
        },
        body: JSON.stringify({
            'data': data,
            'pre_question_id': pre_question_id
        })
    }).then((response) => response.json()).then((responseJson) => {
        this.setState({
            testcont: responseJson.Mcq_details,
            testquestions: responseJson.McqQuestions,
          
        });
        setTimeout(() => {
            contentResizeLoad();
            showSmallLeftMenu();
            contentResizeLoad();
            reactLoader("hide");
        }, 200);
    });
}

submittest(cur_question_id) {
    const {
        data
    } = this.props;
    let isValid = true;
    if(this.state.confidence_meter==1 && this.state.testcont.allowskip==0)
    {
        if(document.getElementById('notsure_'+cur_question_id).checked === true  || document.getElementById('somewhatsure_'+cur_question_id).checked === true || document.getElementById('verysure_'+cur_question_id).checked === true)
        {
            isValid= true;
        }
        else
        {
            isValid= false;
            $('#errorconfident_'+cur_question_id).css('display','block');
        }
    }
    
    if (runValidation() && isValid) {
        let frmaddobserver = $('#frm_mcq').serializeArray(),
            formData = new FormData();
        frmaddobserver.map((key, index) => {
            formData.append(key.name, key.value);
        });
        formData.append('compseq_id', data.compseq_id);
        formData.append('learning_room_id', data.learning_room_id);
        formData.append('learner_id', data.learner_id);
        formData.append('dlr_id', data.dlr_id);
        formData.append('is_ag', data.is_ag);
        formData.append('divider_id', data.divider_id);
        formData.append('mcq_questionary_id', data.id);
        formData.append('question_id', cur_question_id);
        formData.append('question_number', this.state.testcont.question_number);
        reactLoader("show", "Please wait...");
        fetch(domainUrl + 'normal-test/repeatsavenxt', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: formData
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 0) {
                reactLoader("hide");
                this.backToComponentList();
                message(responseJson.message, responseJson.errors, "error");
            } else {
                this.props.getLearningRoom();
                scrollToTop();
                if (responseJson.componentStatus == 'completed') {
                    this.setState({
                        resultpage:true,
                        totalscore:responseJson.resultdata.total_score,
                        outofscore:responseJson.resultdata.out_of_score,
                        is_performance:responseJson.resultdata.performance,
                        percentage:responseJson.resultdata.percentage,
                       
                    });
                } else if (responseJson.is_answered_all == '1') {
                    let evaluationPanel = (responseJson.componentStatus == "incompleted") ? true : false;
                    this.setState({
                        resultpage:true,
                        totalscore:responseJson.resultdata.total_score,
                        outofscore:responseJson.resultdata.out_of_score,
                        is_performance:responseJson.resultdata.performance,
                        percentage:responseJson.resultdata.percentage,
                        componentStatus: responseJson.componentStatus,
                        evaluationPanel: evaluationPanel,
                        is_answered_all: responseJson.is_answered_all
                    });
                } else {
                    setTimeout(() => {
                        this.goback(responseJson.next_id);
                    }, 200);
                }
                reactLoader("hide");
            }
        });
    }
}


getquestion(quest_det,ans_opt,i,imagezoomopt){
    let qty_val=[];
    let question_type = quest_det.question_type;
    let classnam = (ans_opt.options=='video') ? "vleft":'fleft';
    switch (question_type) {
        case 1:
            qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
            <span className="flefts"><input type='radio'  name={quest_det.question_id} onClick={(e)=>handleRadio(e)} value={ans_opt.mcq_answer_id_pk} /></span>
            <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
            </li>
        break;
        case 2:
            qty_val=<li key={`list_${quest_det.question_id}`} className="qleft"><span className="fleft">{i}. </span>
            <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
            </li>;
        break;
        case 3:
            qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
            <span className="flefts"><input type='checkbox'  name={quest_det.question_id} onClick={(e)=>handleCheckbox(e)} value={ans_opt.mcq_answer_id_pk} /></span>
            <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
            </li>;
        break;
        case 4:
            qty_val=<li key={`list_${quest_det.question_id}`} className="qleft testopt">
            <span className="sfleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
            </li>;
        break;
        case 5:
            qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
            <span className="flefts"><input type='radio' name={quest_det.question_id} onClick={(e)=>handleRadio(e)} value={ans_opt.mcq_answer_id_pk} /></span>
            <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
            </li>;
        break;
        

        default:
            qty_val='';
        break;
    }
    return qty_val;
}

matchfillfun(mk,imagezoomopt){
    let validationClass = (this.state.testcont.allowskip == 0) ? 'required ' : '';
    validationClass = validationClass +'sequence';

    return <li key={`list_${mk.question_id}`} className="qleft">
    <p>Match Set A with correct item in Set B<br />Key in the corresponding no. (1,2,3...) in the box provided</p>
    <div className="tab-match-container">
        <table className="tbl-match">
        <tr className="tbl-match-head">
            <td><b>SET A</b></td>
            <td><b>Correct match from Set B</b></td>
            <td><b>SET B</b></td>
        </tr>
        <tbody>
        {mk.mcq_match_filling.map((mc,r)=>{
            return <tr key={`matches_tr_${r}`} className="tbl-match-body">
            <td>
                <div className="statement">
                    {mc.match_ques_type==1 && <center>{mc.match_ques_src}</center>}
                    {mc.match_ques_type==2 && <center>
                        {(imagezoomopt) ? <Imagezoom izsrc={rootDomainUrl+'/admin/test_image_files/'+mc.match_ques_src} izalt="" izwidth="200" izheight="200" /> :
                        <img src={rootDomainUrl+'/admin/test_image_files/'+mc.match_ques_src} alt="" width="200" height="200" />
                        }
                        </center>}
                    {mc.match_ques_type==3 && <audio controls controlsList="nodownload">
                    <source src={rootDomainUrl+"admin/test_audio_files/"+mc.match_ques_src} type="audio/mpeg" />
                    </audio>
                    }
                    {mc.match_ques_type==4 && this.video_frame(mc.match_ques_src, '') }
                </div>
            </td>
            <td>
                <input type="text" name={mk.question_id} className="txtbox matchtxt auto-focus" style={{width: "40px"}} title="Enter numeric input" maxLength="2" onKeyPress={e=>allowOnlyNumberInput(e)} onKeyUp={(e)=>autoFocusNext(e, 'tr')} onBlur={(e)=>handleSequence(e)} />
            </td>
            <td>
                <div>
                    <span style={{float: "left"}}>{r+1}. </span>
                    <div className="statement">
                        {mc.match_ans_type==1 && <center>{mc.match_ans_src}</center>}
                        {mc.match_ans_type==2 && <center>
                            {(imagezoomopt) ? <Imagezoom izsrc={rootDomainUrl+'/admin/test_image_files/'+mc.match_ans_src} izalt="" izwidth="200" izheight="200" /> :
                            <img src={rootDomainUrl+'/admin/test_image_files/'+mc.match_ans_src} alt="" width="200" height="200" />
                            }
                            </center>}
                        {mc.match_ans_type==3 && <audio controls controlsList="nodownload">
                            <source src={rootDomainUrl+"admin/test_audio_files/"+mc.match_ans_src} type="audio/mpeg" /></audio>
                        }
                        {mc.match_ans_type==4 && this.video_frame(mc.match_ans_src, '') }
                    </div>
                </div>
            </td>
            </tr>
        })}
        </tbody>
        </table>
        <input type="hidden" name={`${mk.question_id}_hidden`} className={validationClass} data-max-seq={mk.mcq_match_filling.length}  />
    </div>
    </li>
}

video_frame(video_files, text) {

    const { data } = this.props;
    let trackData={

        compseq_id: data.compseq_id,
        lroom_id: data.learning_room_id,
        divider_id: data.divider_id,
        learner_id: data.learner_id,        
        dlr_id: data.dlr_id,
        compo_type:data.compo_type
    };

    let playlist={
        share:false,
        ratio: 9/16,
        clip:{
            sources: [
                {
                    type: "video/mp4",
                    src: rootDomainUrl+'admin/test_video_files/'+video_files
                }
            ]
        }
    };

	return <Flowplayer playlist={playlist} trackData={trackData} />;
}



continueToComplete() {
	this.setState({ evaluationPanel: true });
}

render() {
    let data=this.state.testcont;
    let testquestions=this.state.testquestions;
    let index=1;
    let seq_op=[];
    let optionText = [];
    let cur_question_id= testquestions.question_id;
    let pre_question_id= data.pre_question_id;
    let checkboxRadioClass = (data.allowskip == 0) ? 'required ' : '',
        sequenceClass = (data.allowskip == 0) ? 'required ' : '',
        optionClass = (data.allowskip == 0) ? 'required ' : '';

    checkboxRadioClass = checkboxRadioClass +'max-select-check';
		sequenceClass = sequenceClass +'sequence';
		optionClass = optionClass +'with-in-options txtbox fillupstxt';


        let resultpagecontent=<div className="main-inner">
        <div className="border-box">
            <div className={data.base_line ? "title-box" : "title-box tit-new"}>

                <div title="Videocomponents" className="ts_active_button"></div>
                <h6>{data.mcq_name ? data.mcq_name : ''}</h6>
                <span>{data.base_line ? data.base_line : ''}</span>
            </div>
            <section className="scrol" id="smana-scroll-inner">
                <section className="viewport">
                    <section className="overview">
                        <div className="inner-content">

                           <div className="test-result">
                                <div className="success-msg">Successfully completed the Session.</div>

                                { this.state.is_performance && <div className="lr-yellow-box lr-yellow-box-repeat"> You have scored <span> {(this.state.percentage!='') ? this.state.percentage+'%' : '0%'} ({((this.state.totalscore != undefined) ? this.state.totalscore : '') + '/' + ((this.state.outofscore != undefined) ? this.state.outofscore : '')})</span> 
                                 </div>}
                                <div className="button">
                                   <input type="submit" value="Continue" title="Continue" className="button_org" onClick={() => this.backToComponentList()} />
                                </div>
                           
                            </div>  
                        </div>   
                    </section>
                </section>
            </section>
        </div>
    </div>;

let confidence_meter=this.state.confidence_meter;
    return (
        (this.state.resultpage) ?   resultpagecontent :  
      <div className="main-inner">
        <div className="border-box">
        <div className={data.base_line?"title-box":"title-box tit-new"}>
            <div title="Videocomponents" className="ts_active_button"></div>
            <h6>{data.mcq_name?data.mcq_name:''}</h6>
            <span>{data.base_line?data.base_line:''}</span>
            </div>

            {data.learner_msg !== "" && this.state.is_answered_all!=1 &&
                <div style={{ float: "left", padding: "10px 0px 10px 0px", marginLeft: "25px" }}>
                    <div className="editortxt">
                    <span dangerouslySetInnerHTML={{ __html: data.learner_msg ? data.learner_msg : '' }} />
                    </div>
                </div>
            }

            <section className="scrol" id="smana-scroll-inner">
              <section className="viewport">
                <section className="overview">
                  <div className="inner-content">
                  

                    { this.state.is_answered_all!=1 &&
                    <form name="frm_mcq" id="frm_mcq" key={`FTa${cur_question_id}`}>
                      <div key={`aT${cur_question_id}`}>
                        <div key={`Ta${cur_question_id}`} className="lr-gray-box test">
                          <div className="graybox_border" key={`gTa${cur_question_id}`}>
                              {(testquestions.hint_for_learner!='' && testquestions.hint_for_learner!=undefined) &&
                              <div key={`hint${cur_question_id}`} className="test-hint">
                             
                              </div>
                              }
                              <span className="blwetxt fleft">Q{data.question_number}. </span>
                              <span className="quetn fleft" dangerouslySetInnerHTML={{ __html:testquestions.mcq_question_name}} />
                              { (testquestions.question_images!=undefined) && testquestions.question_images.map((val,index)=>{
                                  if(val!='' && val!=undefined){
                                    return <div key={`imageq${index}`} className="qleft">
                                    {(data.imagezoom)?
                                    <Imagezoom izsrc={rootDomainUrl+"admin/test_image_files/"+val} izalt="" izwidth={testquestions.img_width} izheight={testquestions.img_height}/> :
                                    <img src={rootDomainUrl+"admin/test_image_files/"+val} alt="" width={testquestions.img_width} height={testquestions.img_height}/>
                                    }
                                    </div>
                                  }
                                })
                              }
                              { (testquestions.question_audio!=undefined) && testquestions.question_audio.map((aval,aindex)=>{
                                if(aval!='' && aval!=undefined){
                                return <div key={`auq${index}`} className="qleft"><audio controls controlsList="nodownload">
                                    <source src={rootDomainUrl+"admin/test_audio_files/"+aval} type="audio/mpeg" />
                                  </audio></div>
                                }
                              })}

                              { (testquestions.question_video!=undefined) && testquestions.question_video.map((vval,vindex)=>{
                                if(vval!='' && vval!=undefined){
                                  return this.video_frame(vval, '');
                                }
                              })}

                              <div key={`dlaopt${index}`} className="test-ques">
                                <div key={`flaopt${index}`} className="ans-select">
                                  <ul key={`ulaopt${index}`}>
                                    {testquestions.question_type==4 && <span className=""><b>your options are: </b></span> }

                                    { (testquestions.question_option_answers!=undefined) && testquestions.question_option_answers.map((qas,i)=>{
                                      if (testquestions.question_type==4) {
                                        optionText.push(qas.options);
                                      } else if (testquestions.question_type==2) {
                                        seq_op.push(<span className="seq-container"><input type="text" name={`${testquestions.question_id}`} className="seq_txtbox auto-focus" maxLength="2" onKeyPress={e=>allowOnlyNumberInput(e)} onKeyUp={(e)=>autoFocusNext(e, '.seq-container')} onBlur={(e)=>handleSequence(e)} /> -</span>);
                                      }
                                      return this.getquestion(testquestions,qas,i+1,data.imagezoom);
                                    })}

                                   

                                    {(testquestions.question_type==7 && (testquestions.mcq_match_filling!=undefined)) && this.matchfillfun(testquestions,data.imagezoom)}

                                    { $.inArray(testquestions.question_type, [1,3,5]) >= 0 &&
                                      <input type="hidden" name={`${testquestions.question_id}_hidden`} className={checkboxRadioClass} data-max-option={testquestions.max_multiple} />
                                    }
                                  </ul>
                                  { testquestions.question_type==8 && <VoiceRecorder questionData={testquestions} /> }

                                  { testquestions.question_type==2 && <div>{seq_op}
                                    <span className="integratestsmalltxt">(Eg: 4 - 3 - 1 - 2.)</span>
                                    <div><input type="hidden" name={`${testquestions.question_id}_hidden`} className={sequenceClass} data-max-seq={testquestions.question_option_answers.length} /></div>
                                    </div>
                                  }
                                  { testquestions.question_type==4 && <span className="integratestsmalltxt">
                                    Ans:<input type="text" name={testquestions.question_id} className={optionClass} data-options={optionText.join(',')} />
                                    </span>
                                  }
                                </div>
                              </div>
                              {confidence_meter==1 ? <Confidencemeter dynamic_confidence={testquestions.question_id}/> : ''}
                            </div>
                          </div>
                          <div id="InActive" className="button bkbtn">
                            <input value="Next" className="Btgoback" type="button" onClick={(e)=>this.submittest(cur_question_id)}/>
                            {data.question_number>1 && data.allowgoback >0 &&
                              <input name="Btgoback" value="Go Back" className="Btgoback" type="button" onClick={(e)=>this.goback(pre_question_id)} />
                            }
                          </div>
                        </div>
                      </form>
                    }

                    
                    </div>
                  </section>
                </section>
              </section>
            </div>
          </div>
      );
  }
}

function mapDispatchToProps(dispatch) {

    return  bindActionCreators({getLearningRoom}, dispatch);

}

export default connect(null,mapDispatchToProps)(RepeatTestonebyone);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/RepeatTestonebyone.js